import { render } from "./DhMapPin.vue?vue&type=template&id=19fe4e34"
import script from "./DhMapPin.vue?vue&type=script&lang=ts"
export * from "./DhMapPin.vue?vue&type=script&lang=ts"
script.render = render

export default script